import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SessionProvider } from '../../../utilities/providers/session.provider';
import { MaterialIconsService } from '../../../services/material-icons.service';
import { GlobalService } from '../../../services/global.service';
import { PermissionsProvider } from '../../../utilities/providers/permissions.provider';
import { RefersUtils } from '../../../utilities/utils/refers.utils';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonModule} from "@angular/material/button";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [NgClass, FormsModule, MatToolbarModule, MatButtonToggleModule, MatIconModule, MatMenuModule, MatButtonModule]
})
export class HeaderComponent implements OnInit, AfterContentChecked {

  headerNavEnum = HeaderNav;
  tabSelected: HeaderNav;
  isLogged = false;
  name = '';
  appMenu = [];

  constructor(private materialIconsService: MaterialIconsService,
              private sessionProvider: SessionProvider,
              private permissionsProvider: PermissionsProvider,
              private globalService: GlobalService,
              private router: Router) {
  }

  ngOnInit() {
    this.changeState();
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (val.url.includes(`/${HeaderNav.SEARCH}`)) {
          this.tabSelected = HeaderNav.SEARCH;

        } else if (val.url.includes(`/${HeaderNav.REFERS}`)) {
          this.tabSelected = HeaderNav.REFERS;

        } else if (val.url.includes(`/${HeaderNav.REPORTS}`) && !val.url.includes(`/${HeaderNav.STORE}`)) {
          this.tabSelected = HeaderNav.REPORTS;

        } else if (val.url.includes(`/${HeaderNav.STORE}`)) {
          this.tabSelected = HeaderNav.STORE;

        } else if (val.url.includes(`/${HeaderNav.PlAN_ADMINISTRATOR}`)) {
          this.tabSelected = HeaderNav.PlAN_ADMINISTRATOR;
        } else if (val.url.includes(`/${HeaderNav.OPERATIONS}`)) {
          this.tabSelected = HeaderNav.OPERATIONS;
        }
        else if (val.url.includes(`/${HeaderNav.APPLE_ABM}`)) {
          this.tabSelected = HeaderNav.APPLE_ABM;
        }
        else if (val.url.includes(`/${HeaderNav.WMT}`)) {
          this.tabSelected = HeaderNav.WMT;
        }
          //  else if (val.url.includes(`/${HeaderNav.STORE_INVASIONS}`)) {
          //   this.tabSelected = HeaderNav.STORE_INVASIONS;
        // }

        else {
          this.tabSelected = null;
        }
      }
    });
  }

  ngAfterContentChecked(): void {
    if (this.isLogged !== this.sessionProvider.isLogged()) {
      this.changeState();
    }
  }

  changeState() {
    
    this.isLogged = this.sessionProvider.isLogged();
    this.name = this.sessionProvider.getUserName();

    this.setMenu();
  }

  tabChanged() {
    if (this.tabSelected === 'refers') {
      this.router.navigate([RefersUtils.redirectReferRoute()]).then();
    } else {
      console.log("entro",this.tabSelected)
      this.redirectTo(this.tabSelected);
    }
  }

  navigateHome() {
    if (this.hasPermission(HeaderNav.HOME)) {
      this.redirectTo(HeaderNav.HOME);
    }
  }

  hasPermission(path: string): boolean {
    return this.permissionsProvider.hasPermission(`/${path}`);
  }

  logout() {
    this.globalService.logout();
  }

  private setMenu() {
    this.appMenu = [
      {
        name: 'Búsqueda', endPath: HeaderNav.SEARCH,
        enable: this.hasPermission(HeaderNav.SEARCH)
      },
      {
        name: 'Reportes', endPath: HeaderNav.REPORTS,
        enable: this.hasPermission(HeaderNav.REPORTS)
      },
      {
        name: 'Tienda en Línea', endPath: HeaderNav.STORE,
        enable: this.hasPermission(HeaderNav.STORE)
      },
      // {
      //   name: 'Tienda Invasiones', endPath: HeaderNav.STORE_INVASIONS,
      //   enable: this.hasPermission(HeaderNav.STORE_INVASIONS)
      // },
      {
        name: 'Apple ABM', endPath: HeaderNav.APPLE_ABM,
        enable: this.hasPermission(HeaderNav.APPLE_ABM)
      },
      {
        name: 'Referidos', endPath: HeaderNav.REFERS,
        enable: this.hasPermission(HeaderNav.REFERS)
      },
      /*
      {
        name: 'Portal Externo', endPath: HeaderNav.PORTAL,
        enable: this.hasPermission(HeaderNav.PORTAL)
      },
       */
      {
        name: 'Operaciones', endPath: HeaderNav.OPERATIONS,
        enable: this.hasPermission(HeaderNav.OPERATIONS)
      },
      {
        name: 'Administrador de Planes', endPath: HeaderNav.PlAN_ADMINISTRATOR,
        enable: this.hasPermission(HeaderNav.PlAN_ADMINISTRATOR)
      },
      {
        name: 'Where Is My Tech', endPath: HeaderNav.WMT,
        // enable: this.hasPermission(HeaderNav.WMT)
        enable: true
      }
    ];
  }

  private redirectTo(endUrl: HeaderNav) {
    this.router.navigate(['/', endUrl]);
  }
}

export enum HeaderNav {
  HOME = 'home',
  SEARCH = 'search',
  STORE = 'store',
  STORE_INVASIONS = 'invasions',
  REPORTS = 'reports',
  REFERS = 'refers',
  PORTAL = 'portal',
  OPERATIONS = 'operations',
  PlAN_ADMINISTRATOR = 'administrator',
  WMT = 'wmt',
  APPLE_ABM = 'apple-abm'
}
